import { render } from "./CustomModal.vue?vue&type=template&id=1906fdbc"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CustomModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1906fdbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1906fdbc', __exports__)) {
    api.reload('1906fdbc', __exports__)
  }
  
  module.hot.accept("./CustomModal.vue?vue&type=template&id=1906fdbc", () => {
    api.rerender('1906fdbc', render)
  })

}


export default __exports__